function formatStandardRupee(amount) {
  // Handle edge cases
  if (isNaN(amount)) return "Invalid amount";

  const isNegative = amount < 0;
  const absAmount = Math.abs(amount);

  // Format to 2 decimal places
  const formattedNumber = absAmount.toFixed(2);

  // Split into integer and decimal parts
  const [integerPart, decimalPart] = formattedNumber.split(".");

  // Add Indian comma formatting (last 3 digits, then groups of 2)
  let formattedInteger = "";
  const reversedInteger = integerPart.split("").reverse().join("");

  for (let i = 0; i < reversedInteger.length; i++) {
    if (i === 3) {
      formattedInteger = "," + formattedInteger;
    } else if (i > 3 && (i - 3) % 2 === 0) {
      formattedInteger = "," + formattedInteger;
    }
    formattedInteger = reversedInteger[i] + formattedInteger;
  }

  const result = `${formattedInteger}.${decimalPart}`;

  return isNegative ? "-" + result : result;
}
export default formatStandardRupee;
